import geolib from 'geolib';
import { }    from './../classes/Distance';

export const SHOW_DIRECTIONS    = 'SHOW_DIRECTIONS';
export const FETCH_DIRECTIONS   = 'FETCH_DIRECTIONS';
export const RECEIVE_DIRECTIONS = 'RECEIVE_DIRECTIONS';
export const DIRECTIONS_ERROR   = 'DIRECTIONS_ERROR';
export const RESET_DIRECTIONS   = 'RESET_DIRECTIONS';

const getGoogleLatLng = (coords) => {
    return new window.google.maps.LatLng(coords.lat, coords.long)
};

export const showDirections = (place) => {
    return (dispatch) => {
        dispatch({
            type : SHOW_DIRECTIONS,
            place: place
        })
    }

};

export const receiveDirections = (directions, status) => {
    return (dispatch) => {
        dispatch({
            type      : RECEIVE_DIRECTIONS,
            directions: directions,
            status    : status
        });
    }
};


export const directionsError = (status) => {
    return (dispatch) => {
        dispatch({
            type  : DIRECTIONS_ERROR,
            status: status
        });
    }
};

export const resetDirections = {
    type: RESET_DIRECTIONS
};

export const fetchDirections = (origin, destination) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DIRECTIONS });

        let travelMode = window.google.maps.TravelMode.WALKING;

        let from = { latitude: origin.lat, longitude: origin.long };
        let to   = { latitude: destination.lat, longitude: destination.long };
        let distance = geolib.getDistance(from, to);
        if (1500 <= distance)
        {
            travelMode = window.google.maps.TravelMode.DRIVING;
        }

        const DirectionsService = new window.google.maps.DirectionsService();
        DirectionsService.route({
            origin     : getGoogleLatLng(origin),
            destination: getGoogleLatLng(destination),
            travelMode : travelMode
        }, (result, status) =>
        {
            if (status === window.google.maps.DirectionsStatus.OK)
            {
                dispatch(receiveDirections(result, status));
            }
            else
            {
                dispatch(directionsError(status));
                dispatch(resetDirections)
            }
        });
    }
};


// WEBPACK FOOTER //
// ./src/actions/DirectionsAction.js